var map = {
	"./bug.svg": 42,
	"./dark.svg": 43,
	"./dragon.svg": 44,
	"./electric.svg": 45,
	"./fairy.svg": 46,
	"./fighting.svg": 47,
	"./fire.svg": 48,
	"./flying.svg": 49,
	"./ghost.svg": 50,
	"./grass.svg": 51,
	"./ground.svg": 52,
	"./ice.svg": 53,
	"./normal.svg": 54,
	"./poison.svg": 55,
	"./psychic.svg": 56,
	"./rock.svg": 57,
	"./steel.svg": 58,
	"./water.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;